import { PropertiesTableProps } from '../../../../shared/types'
import { stringProperties } from '../String/StringDocs'

export const NameProperties: PropertiesTableProps = {
  ...stringProperties,
}
